/* eslint-disable no-undef, no-param-reassign, prefer-template, no-continue, prefer-destructuring, no-plusplus */
if (typeof CSS === "undefined" || typeof CSS.escape !== "function") {
  (function CSSPolyfill(global) {
    const cssEscape = function cssEscape(value) {
      if (value == null) {
        throw new TypeError("`CSS.escape` requires a string argument.");
      }

      const string = String(value);
      const length = string.length;
      let result = "";

      for (let i = 0; i < length; i++) {
        const codeUnit = string.charCodeAt(i);

        // Escape NULL character
        if (codeUnit === 0x0000) {
          result += "\uFFFD";
          continue;
        }

        // Control characters and DEL
        if ((codeUnit >= 0x0001 && codeUnit <= 0x001f) || codeUnit === 0x007f) {
          result += "\\" + codeUnit.toString(16) + " ";
          continue;
        }

        // Escape leading digit or dash followed by digit
        if (i === 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039) {
          result += "\\" + string.charAt(i);
          continue;
        }

        if (
          i === 1 &&
          string.charAt(0) === "-" &&
          codeUnit >= 0x0030 &&
          codeUnit <= 0x0039
        ) {
          result += "\\" + string.charAt(i);
          continue;
        }

        // Escape if character is ASCII or special CSS syntax
        if (
          codeUnit >= 0x0080 ||
          codeUnit === 0x002d ||
          codeUnit === 0x005f || // underscore
          (codeUnit >= 0x0030 && codeUnit <= 0x0039) || // 0-9
          (codeUnit >= 0x0041 && codeUnit <= 0x005a) || // A-Z
          (codeUnit >= 0x0061 && codeUnit <= 0x007a) // a-z
        ) {
          result += string.charAt(i);
          continue;
        }

        result += "\\" + string.charAt(i);
      }

      return result;
    };

    if (typeof global.CSS === "undefined") {
      global.CSS = {};
    }

    global.CSS.escape = cssEscape;
  })(typeof globalThis !== "undefined" ? globalThis : window);
}
